var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddSquare = function SvgAddSquare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Line / add-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-393.000000, -678.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(393.000000, 678.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,0 C22.3210678,0 24,1.67893219 24,3.75 L24,3.75 L24,20.25 C24,22.3210678 22.3210678,24 20.25,24 L20.25,24 L3.75,24 C1.67893219,24 0,22.3210678 0,20.25 L0,20.25 L0,3.75 C0,1.67893219 1.67893219,0 3.75,0 L3.75,0 Z M20.25,1.5 L3.75,1.5 C2.50735931,1.5 1.5,2.50735931 1.5,3.75 L1.5,3.75 L1.5,20.25 C1.5,21.4926407 2.50735931,22.5 3.75,22.5 L3.75,22.5 L20.25,22.5 C21.4926407,22.5 22.5,21.4926407 22.5,20.25 L22.5,20.25 L22.5,3.75 C22.5,2.50735931 21.4926407,1.5 20.25,1.5 L20.25,1.5 Z M12,6.75 C12.3796958,6.75 12.693491,7.03215388 12.7431534,7.39822944 L12.75,7.5 L12.75,11.25 L16.5,11.25 C16.9142136,11.25 17.25,11.5857864 17.25,12 C17.25,12.3796958 16.9678461,12.693491 16.6017706,12.7431534 L16.5,12.75 L12.75,12.75 L12.75,16.5 C12.75,16.9142136 12.4142136,17.25 12,17.25 C11.6203042,17.25 11.306509,16.9678461 11.2568466,16.6017706 L11.25,16.5 L11.25,12.75 L7.5,12.75 C7.08578644,12.75 6.75,12.4142136 6.75,12 C6.75,11.6203042 7.03215388,11.306509 7.39822944,11.2568466 L7.5,11.25 L11.25,11.25 L11.25,7.5 C11.25,7.08578644 11.5857864,6.75 12,6.75 Z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-square.723bb71785d87bc28e19d8ebc15a3966.svg";